import { useState, useEffect } from 'react';
import taxService from '../services/taxService';

export const useTaxSummary = (startDate, endDate) => {
  const [summary, setSummary] = useState(null);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  useEffect(() => {
    const fetchSummary = async () => {
      if (!startDate || !endDate) return;
      
      setLoading(true);
      try {
        const data = await taxService.getTaxSummary(startDate, endDate);
        setSummary(data);
        setError(null);
      } catch (err) {
        setError(err.message);
      } finally {
        setLoading(false);
      }
    };

    fetchSummary();
  }, [startDate, endDate]);

  return { summary, loading, error };
};

export const useGSTReports = () => {
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(null);

  const generateGSTR1 = async (month, year) => {
    setLoading(true);
    try {
      const report = await taxService.generateGSTR1(month, year);
      setError(null);
      return { success: true, data: report };
    } catch (err) {
      setError(err.message);
      return { success: false, error: err.message };
    } finally {
      setLoading(false);
    }
  };

  const generateGSTR3B = async (quarter, year) => {
    setLoading(true);
    try {
      const report = await taxService.generateGSTR3B(quarter, year);
      setError(null);
      return { success: true, data: report };
    } catch (err) {
      setError(err.message);
      return { success: false, error: err.message };
    } finally {
      setLoading(false);
    }
  };

  const generateGSTR9 = async (year) => {
    setLoading(true);
    try {
      const report = await taxService.generateGSTR9(year);
      setError(null);
      return { success: true, data: report };
    } catch (err) {
      setError(err.message);
      return { success: false, error: err.message };
    } finally {
      setLoading(false);
    }
  };

  return {
    loading,
    error,
    generateGSTR1,
    generateGSTR3B,
    generateGSTR9
  };
};

export const useTaxLiability = (startDate, endDate) => {
  const [liability, setLiability] = useState(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const fetchLiability = async () => {
      if (!startDate || !endDate) return;
      
      setLoading(true);
      try {
        const data = await taxService.getTaxLiabilityReport(startDate, endDate);
        setLiability(data);
      } catch (error) {
        console.error('Error fetching tax liability:', error);
      } finally {
        setLoading(false);
      }
    };

    fetchLiability();
  }, [startDate, endDate]);

  return { liability, loading };
};

export const useIndianStates = () => {
  const [states, setStates] = useState([]);

  useEffect(() => {
    const indianStates = taxService.getIndianStates();
    setStates(indianStates);
  }, []);

  return states;
};

export const useCompanyInfo = () => {
  const [companyInfo, setCompanyInfo] = useState(null);

  useEffect(() => {
    const info = taxService.getCompanyInfo();
    setCompanyInfo(info);
  }, []);

  return companyInfo;
};